import { c as _c } from "react/compiler-runtime";
import type { FC, SVGProps } from "react";

// Source: https://fonts.google.com/icons?icon.query=arrow+me&selected=Material+Symbols+Rounded:arrow_menu_open:FILL@0;wght@300;GRAD@0;opsz@24&icon.size=24&icon.color=%23e3e3e3&icon.style=Rounded
export const ArrowMenuOpenIcon: FC<SVGProps<SVGSVGElement>> = props => {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <title>Arrow Menu Open Icon</title>;
    t1 = <path d="M9.5 19.75V4.25C9.5 4.0375 9.57192 3.85942 9.71575 3.71575C9.85958 3.57192 10.0378 3.5 10.2503 3.5C10.4629 3.5 10.641 3.57192 10.7845 3.71575C10.9282 3.85942 11 4.0375 11 4.25V19.75C11 19.9625 10.9281 20.1406 10.7842 20.2843C10.6404 20.4281 10.4622 20.5 10.2497 20.5C10.0371 20.5 9.859 20.4281 9.7155 20.2843C9.57183 20.1406 9.5 19.9625 9.5 19.75ZM13.1923 15.2135V8.79625C13.1923 8.58158 13.2842 8.43592 13.4682 8.35925C13.6522 8.28258 13.818 8.32117 13.9655 8.475L16.8193 11.3672C16.9936 11.5481 17.0807 11.759 17.0807 12C17.0807 12.241 16.9936 12.4519 16.8193 12.6328L13.9655 15.525C13.818 15.6788 13.6522 15.7181 13.4682 15.6427C13.2842 15.5674 13.1923 15.4243 13.1923 15.2135Z" fill="currentColor" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props) {
    t2 = <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}{t1}</svg>;
    $[2] = props;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};